export default __webpack_public_path__ + "static/media/mathema.d9ce8dc2.svg";